module.exports = __webpack_public_path__ + "img/17.a298d783.jpg";